<template>
  <div>
    <div class="row">
      <div class="col-6 col-md-4">
        <under-input v-model="item.core.race">Race</under-input>
      </div>
      <div class="col-6 col-md-4">
        <under-input v-model="item.core.class">Profession</under-input>
      </div>
      <div class="col-6 col-md-2">
        <under-input v-model="item.core.experience">Experience</under-input>
      </div>
      <div class="col-6 col-md-2">
        <under-text>
          <span slot="underline">{{level}}</span>
          Rank
        </under-text>
      </div>
    </div>
  </div>
</template>
<script>
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "character-sheet-core-fifth-edition",
  components: {
    UnderInput,
    UnderSelect,
    UnderText
  },
  props: ["item"],
  computed: {
    level() {
      return this.$rulesets[this.item.ruleset].getRank(
        this.item.core.experience
      );
    }
  }
};
</script>
